import { useEffect, useState } from 'react';

const useResponsive = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const handleResize = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isMobile = windowSize.width < 450;
  const isTablet = windowSize.width >= 450 && windowSize.width <= 1024;
  const isLaptop = windowSize.width > 1024 && windowSize.width <= 1440;
  const isDesktop = windowSize.width > 1440;

  return { windowSize, isMobile, isTablet, isDesktop, isLaptop };
};

export default useResponsive;
